import React, { useEffect, useReducer, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import { GetZipCode, ServerRequestProtected, ServerRequestPublic } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import isNull from "../../../../utils/NullChecking"
import Loader from "../../../shared/Loader/Loader"
import Modal from 'react-bootstrap/Modal';
import States, { Gender } from "../../../../utils/Constants"
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Audit from "../../../General/Audit"
import { useDispatch, useSelector } from "react-redux"
import ModalHeader from "../../Shared/ModalHeader"
import { Nav, NavItem, NavLink } from 'reactstrap'
import { TabContent, TabPane } from 'reactstrap'
import AssignedProfile from "./AssignedProfile"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import DropdownValueHandler from "../../../shared/SuperSearch/DropdownValueHandler"
import UpdateReduxDropDowns from "../../../shared/UpdateReduxDropDowns"
import { SelectColumn } from "react-data-grid"
import BasicInformation from "./BasicInformation"
import ResetUserPassword from "./ResetUserPassword"
import UserBillingRights from "./UserBillingRights"
import DeactiveUser from './DeactiveUser'
import { FindSecondChild } from "../../../../utils/FindMenuOption"
import ModalFooter from "../../Shared/ModalFooter"
const AddNewUser = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'User Management', 'User')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'User Management', 'User')?.IsDeleted

    // console.log(IsDeleteAllowed, 'IsDeleteAllowed');

    // General 
    const { isOpenUser, onClose, onDeleteUser, onCloseSave, Refreash } = { ...props }
    let DropDowns = useSelector(state => state?.GeneralDropDownsReducer)
    let PracicesDropDown = [...DropDowns?.UserPractices];
    const [practicesDropDown, setPracticesDropDown] = useState(PracicesDropDown);
    const API_URL = enumUtil.controller.Login
    const API_URL_General = enumUtil.controller.General
    const API_URL_Wasabi = enumUtil.controller.Wasabi

    let User_Modal = {
        Email: "",
        FirstName: "",
        LastName: "",
        MiddleName: "",
        Gender: '',
        Address: "",
        City: "",
        State: "",
        ZipCode: "",
        RoleID: "",
        Picture: "",
        Reset: "",
        UserType: "",
        ProviderID: "",
        IsProvider: false,
        IsStaff: false,
        StaffID: '',
        LocationID: "",
        Password: "",
        DepartmentID: "",
        DesignationID: "",
        CreatedBy: '',
        CreatedDate: '',
        IsPublicAccessible: '',
        Cell: '',
        PhoneNumber: "",
        requireBAA: false,

    }
    let valModal = {}
    let ValidationModal = {
        FirstNameVal: "",
        LastNameVal: "",
        EmailVal: "",
        GenderVal: "",

        // RoleVal: "",
        UserTypeVal: "",
        // LocationVal: "",
        ProviderVal: "",
        StaffVal: '',
        ZipCodeVal: "",
        ZipCodeLengthVal: "",
        UserRoleVal: ""
    }
    const [practiceID, setPracticeID] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    // BasicInfo
    const [UserSaveUpdateModal, setUserSaveUpdateModal] = useState({})
    const [mainUserModal, setmainUserModal] = useState(User_Modal);
    const [UserValidationModal, setUserValidationModal] = useState(ValidationModal)
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [onUserSaved, setonUserSaved] = useState(false)
    const [is, setIs] = useState(false);
    const [userID, setUserID] = useState();
    const [isUserSaved, setisUserSaved] = useState()
    const [additionalRoles, setAdditionalRoles] = useState('');
    const [initialAdditionalRoles, setInitialAdditionalRoles] = useState([]);
    const [additionalRolesKey, setAdditionalRolesKey] = useState(0);
    const [RolesDD, setRolesDD] = useState([])
    let rolesDD = []
    const loadUserDropDown = () => {
        ServerRequestProtected(API_URL_General + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.Roles,
        }).then((response) => {
            setIsLoading(false)
            rolesDD = response
            setRolesDD(rolesDD)
        }).catch((error) => {
            setIsLoading(false)
        })
    }


    // const LoaduserImage = async (imgURL) => {

    //     try {
    //         const response = await ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
    //             "BucketPath": imgURL.Picture,
    //         }, "Download")
    //         // setIsLoading(true);

    //         if (response.type === 'application/jpg') {
    //             const blob = response
    //             const objectURL = URL.createObjectURL(blob);
    //             console.log('objectURL', objectURL);
    //             return objectURL

    //         }
    //         // setIsLoading(false);

    //     } catch (error) {
    //         // setIsLoading(false);
    //         throw error;
    //     }
    // }

    // const FindByUserID = async () => {
    //     try {
    //         setIsLoading(true);

    //         // Load roles
    //         const rolesResponse = await ServerRequestProtected(API_URL_General + "/DropDown", 'post', {
    //             TableName: enumUtil.enumAPITableName.Roles,
    //         });

    //         rolesDD = rolesResponse;
    //         setRolesDD(rolesDD);

    //         // Load user by ID
    //         if (!isNull(userID)) {
    //             const userResponse = await ServerRequestProtected(API_URL + "/FindByID", 'post', {
    //                 ID: userID,
    //                 TableName: enumUtil.enumAPITableName.User
    //             });

    //             setIs(true);

    //             // if (userResponse.Picture) {
    //             //     userResponse.Picture = await LoaduserImage(userResponse);
    //             // }
    //             userResponse.State = DropdownValueHandler(States, userResponse.State);
    //             userResponse.RoleID = DropdownValueHandler(rolesDD, userResponse.RoleID);
    //             userResponse.LocationID = DropdownValueHandler(DropDowns.Location, userResponse.LocationID);
    //             userResponse.ProviderID = DropdownValueHandler(DropDowns.Provider, userResponse.ProviderID);
    //             userResponse.DesignationID = DropdownValueHandler(DropDowns?.Designation, userResponse.DesignationID);
    //             userResponse.DepartmentID = DropdownValueHandler(DropDowns?.Department, userResponse.DepartmentID);
    //             userResponse.Gender = DropdownValueHandler(Gender, userResponse.Gender);

    //             setmainUserModal(userResponse); 
    //         }
    //         if (userResponse.Picture) {
    //             const imageURL = await LoaduserImage(userResponse.Picture);
    //             setmainUserModal(prev => ({ ...prev, Picture: imageURL }));
    //         }
    //         setIsLoading(false);
    //     } catch (error) {
    //         NotificationHandler(error?.response?.data || "Error occurred", enumUtil.enumtoaster.error);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };
    const LoaduserImage = async (imgURL) => {
        try {
            const response = await ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
                "BucketPath": imgURL.Picture,
            }, "Download");

            if (response.type === 'application/jpg') {
                const blob = response;
                const objectURL = URL.createObjectURL(blob);
                return objectURL;
            }

        } catch (error) {
            console.error("Image loading error:", error);
            return null;
        }
    };

    const FindByUserID = async () => {
        try {
            setIsLoading(true);

            const rolesResponse = await ServerRequestProtected(API_URL_General + "/DropDown", 'post', {
                TableName: enumUtil.enumAPITableName.Roles,
            });

            const rolesDD = rolesResponse;
            setRolesDD(rolesDD);

            if (!isNull(userID)) {
                const userResponse = await ServerRequestProtected(API_URL + "/FindByID", 'post', {
                    ID: userID,
                    TableName: enumUtil.enumAPITableName.User
                });

                setIs(true);
                const tempUser = {
                    ...userResponse,
                    State: DropdownValueHandler(States, userResponse.State),
                    RoleID: DropdownValueHandler(rolesDD, userResponse.RoleID),
                    LocationID: DropdownValueHandler(DropDowns.Location, userResponse.LocationID),
                    ProviderID: DropdownValueHandler(DropDowns.Provider, userResponse.ProviderID),
                    DesignationID: DropdownValueHandler(DropDowns?.Designation, userResponse.DesignationID),
                    DepartmentID: DropdownValueHandler(DropDowns?.Department, userResponse.DepartmentID),
                    Gender: DropdownValueHandler(Gender, userResponse.Gender),
                    StaffID: DropdownValueHandler(DropDowns?.Staff, userResponse.StaffID),

                };
                setmainUserModal(tempUser);
                if (userResponse.Picture) {
                    const imageURL = await LoaduserImage(userResponse);
                    setmainUserModal(prev => ({ ...prev, Picture: imageURL }));
                }
            }

        } catch (error) {
            NotificationHandler(error?.response?.data || "Error occurred", enumUtil.enumtoaster.error);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        if (props.UserID != null) {
            setDel(true)
            setUserID(props.UserID)
        } else {
            if (!onUserSaved) {
                setUserID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        FindByUserID()
    }, [userID, isUserSaved])
    const handleUserChange = (e) => {
        setIs(true);
        let { name, value, type, checked } = e.target;

        if (name !== "Email" && process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase();
        }

        let modal = { ...mainUserModal };
        let saveModal = { ...UserSaveUpdateModal };

        if (name === 'ZipCode') {
            GetZipCode(value)
                .then(data => {
                    setmainUserModal(prevState => ({ ...prevState, ...data?.main }));
                    setUserSaveUpdateModal(prevState => ({ ...prevState, ...data?.save }));
                })
                .catch(error => { });
            modal[name] = value;
        } else {
            if (type === 'checkbox') {
                modal[name] = checked;
            } else {
                modal[name] = value;
            }
        }

        setmainUserModal(modal);

        for (var property in User_Modal) {
            if (name === property) {
                if (type === 'checkbox') {
                    saveModal[name] = checked.toString(); // "true" or "false"
                } else {
                    saveModal[name] = value;
                }
            }
        }

        setUserSaveUpdateModal(saveModal);
    };

    const handleImageChange = (e) => {
        const Type = e.target.files[0].type.substring(0, 5);
        if (Type === 'image') {
            let file = e.target.files[0]
            let reader = new FileReader();
            reader.onloadend = () => {
                let value = reader.result.toString();
                setmainUserModal({ ...mainUserModal, Picture: value })
                setUserSaveUpdateModal({ ...UserSaveUpdateModal, Picture: value })
            }
            reader.readAsDataURL(file);
        }

    }
    const SetUserName = () => {
        if (!isNull(mainUserModal.FirstName) && !isNull(mainUserModal.LastName)) {
            return (
                <p className="heading sm">{mainUserModal.FirstName}{' '}{mainUserModal.LastName}</p>
            )
        } else {
            return (
                <p className="heading sm">Add new user</p>
            )
        }
    }
    const UserValidation = async () => {
        const ValidationModal = {
            FirstNameVal: FormValidator(
                mainUserModal.FirstName,
                enumUtil.enumValidationType.Required,
                'First Name'
            ),
            LastNameVal: FormValidator(
                mainUserModal.LastName,
                enumUtil.enumValidationType.Required,
                'Last Name'
            ),
            EmailVal: FormValidator(
                mainUserModal.Email,
                enumUtil.enumValidationType.Required,
                'Email'
            ),
            GenderVal: FormValidator(
                mainUserModal.Gender,
                enumUtil.enumValidationType.Required,
                'Gender'
            ),
            UserTypeVal: FormValidator(
                mainUserModal.UserType,
                enumUtil.enumValidationType.Required,
                'User Type'
            ),
            ZipCodeLengthVal: FormValidator(
                mainUserModal.ZipCode,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            UserRoleVal: FormValidator(
                UserRoleid,
                enumUtil.enumValidationType.Required,
                'Role'
            ),

            ...(mainUserModal?.IsProvider === 'True' ||
                mainUserModal?.IsProvider === 'true' ||
                mainUserModal?.IsProvider
                ? {
                    ProviderVal: FormValidator(
                        mainUserModal.ProviderID,
                        enumUtil.enumValidationType.Required,
                        'Provider'
                    )
                }
                : {}),
            ...(mainUserModal?.IsStaff === 'True' ||
                mainUserModal?.IsStaff === 'true' ||
                mainUserModal?.IsStaff
                ? {
                    StaffVal: FormValidator(
                        mainUserModal.StaffID,
                        enumUtil.enumValidationType.Required,
                        'Staff'
                    )
                }
                : {})
        };

        await setUserValidationModal(ValidationModal);
        valModal = ValidationModal;
    };


    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainUserModal };
        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            UserSaveUpdateModal[name] = selectedData.value + "";
        } else if (type === 'server' && !isNull(selectedData)) {
        } else {
            modal[name] = ''
            UserSaveUpdateModal[name] = ''
        }
        setmainUserModal(modal)
        return selectedData
    }
    const handleDeleteModal = () => { setisOpenAlert(true) }
    const onCloseDelete = () => { setisOpenAlert(false) }
    const handleAuditModal = () => { setisOpenAudit(true) }
    const onCloseAudit = () => { setisOpenAudit(false) }
    let DeletePopup = "";
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.User} ID={userID} onClose={onDeleteUser} />
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={userID + ""} TableName={enumUtil.enumAPITableName.UserAudit} />
    }
    // Assigned Profiles
    const [isCheckedAllProviders, setIsCheckedAllProviders] = useState(false);
    const [isCheckedAllLocations, setIsCheckedAllLocations] = useState(false);
    const [selectedPracticeID, setSelectedPracticeID] = useState(null);
    let Assigned_Modal = {
        isPracticeAssigned: false,
        isRoleAssigned: false,
        isProviderAssigned: true,
        isLocationAssigned: true,
        isSaved: true,
        isAssignedProviderLength: true,
        isAssignedLocationLength: true,
    }
    const [assignedPractices, setAssignedPractices] = useState([])
    const [unAssignedProviders, setunAssignedProviders] = useState([]);
    const [AssignedProviders, setAssignedProviders] = useState([]);
    const [unAssignedLocations, setunAssignedLocations] = useState([]);
    const [AssignedLocations, setAssignedLocations] = useState([]);
    const [isAssigned, setIsAssigned] = useState(Assigned_Modal);
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [UserRole, setUserRole] = useState('')
    const [UserRoleid, setUserRoleid] = useState('')
    const [UserRolesDD, setUserRolesDD] = useState([])
    const [deActive, setDeActive] = useState({})

    const FindByPracrice = (id) => {
        if (!isNull(id)) {
            if (isAssigned.isLocationAssigned && isAssigned.isProviderAssigned && isAssigned.isSaved) {
                setSelectedPracticeID(id + "")
                const idSet = new Set([id + ""])
                const selectedRowsArray = Array.from(new Set([...idSet]));
                const lastitem = selectedRowsArray[selectedRowsArray.length - 1];
                setIsLoading(true)
                ServerRequestProtected(API_URL + "/FindProviderLocation", 'post', {
                    "SelectedUserID": userID,
                    "ID": id + "",
                    "TableName": enumUtil.enumAPITableName.User
                }).then((response) => {
                    if (!isNull(response.UnAssingedProvider) && response.UnAssingedProvider.length > 0) {
                        response.UnAssingedProvider.map((item, index) => {
                            item['isChecked'] = false
                        })
                    }
                    setunAssignedProviders(response.UnAssingedProvider)
                    if (!isNull(response.AssignedProvider) && response.AssignedProvider.length > 0) {
                        response.AssignedProvider.map((item, index) => {
                            item['isChecked'] = false
                        })
                    }
                    setAssignedProviders(response.AssignedProvider)

                    if (!isNull(response.AssignedLocation) && response.AssignedLocation.length > 0) {
                        response.AssignedLocation.map((item, index) => {
                            item['isChecked'] = false
                        })
                    }
                    setAssignedLocations(response.AssignedLocation)
                    if (!isNull(response.UnAssingedLocation) && response.UnAssingedLocation.length > 0) {
                        response.UnAssingedLocation.map((item, index) => {
                            item['isChecked'] = false
                        })
                    }
                    if (!isNull(response.AssignedRole) && response.AssignedRole.length > 0) {
                        setUserRole(response.AssignedRole[0].display)
                        setUserRoleid(response.AssignedRole[0].value)

                    } else {
                        setUserRole('')
                        setUserRoleid('')
                    }
                    let allRoles = [...response.UnAssignRole];

                    if (response.AssignedAdditionalRole && response.AssignedAdditionalRole.length > 0) {
                        response.AssignedAdditionalRole.forEach(role => {
                            if (!allRoles.some(r => String(r.value) === String(role.value))) {
                                allRoles.push({
                                    value: role.value,
                                    display: role.display
                                });
                            }
                        });
                    }

                    setUserRolesDD(allRoles)

                    setDeActive(response?.DeActiveUser)
                    setunAssignedLocations(response.UnAssingedLocation)

                    // Load additional roles if they exist
                    if (response.AssignedAdditionalRole && response.AssignedAdditionalRole.length > 0) {
                        const activeRoles = response.AssignedAdditionalRole;

                        const roleIdsString = activeRoles.map(role => role.value).join(', ');
                        const selectedRoles = [];
                        activeRoles.forEach(role => {
                            const match = allRoles.find(r => String(r.value) === String(role.value));
                            if (match) {
                                selectedRoles.push(match);
                            }
                        });


                        setInitialAdditionalRoles(selectedRoles);
                        setAdditionalRoles(roleIdsString);
                        setAdditionalRolesKey(prev => prev + 1);
                    } else {
                        setInitialAdditionalRoles([]);
                        setAdditionalRoles('');
                        setAdditionalRolesKey(prev => prev + 1);
                    }

                    setPracticeName("");
                    setIsLoading(false);
                    setSelectedRows(new Set([lastitem]));
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
            }
            else if (!isAssigned.isLocationAssigned && !isAssigned.isProviderAssigned && !isAssigned.isSaved) {
                NotificationHandler("Please Assign Provider and Location", enumUtil.enumtoaster.error);
            }
            else if (!isAssigned.isProviderAssigned) {
                NotificationHandler("Please Assign Provider", enumUtil.enumtoaster.error);
            }
            else if (!isAssigned.isLocationAssigned) {
                NotificationHandler("Please Assign Location", enumUtil.enumtoaster.error);
            }
            else if (!isAssigned.isSaved) {
                NotificationHandler("Please Save Assigned Record", enumUtil.enumtoaster.error);
            }
        }
    }

    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    const columns = [
        {
            ...SelectColumn,
            renderCell({ row, isCellSelected, onRowChange }) {
                return SelectColumn.renderCell({ row, isCellSelected, onRowChange });
            },
        },
        {
            key: 'PracticeName',
            name: 'Name',
            headerRenderer: (row) => (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Name'} sortIcon={true} type={'string'} colKey={'PracticeName'} data={assignedPractices} setData={setAssignedPractices} />),
            resizable: true,
            width: 245,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="validation_message" title={row.PracticeName}>
                            {row.PracticeName}
                        </div>
                    </>
                );
            },
        },
        {
            key: 'AssignedDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={' Date'} sortIcon={true} type={'string'} colKey={'AssignedDate'} data={assignedPractices} setData={setAssignedPractices} />),
            resizable: true,
        },
        {
            key: 'Remove',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={''} sortIcon={true} type={'string'} colKey={'Remove'} data={assignedPractices} setData={setAssignedPractices} />),
            width: 35,
            minWidth: 35,
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <button className="btn btn-transparent min-w-unset" onClick={() => handleRemovePractice(row.PracticeID)}>
                        <i className="icon-delete text-danger"></i>
                    </button>
                );
            },
        },
    ];
    const [practiceName, setPracticeName] = useState('')
    const [practiceModal, setPracticeModal] = useState()
    const [confirmPractice, setconfirmPractice] = useState(false)


    const handleChangeUserRole = (e) => {
        setIs(true)
        let { value, name } = e.target
        setUserRole(value)

    }
    const handleSelectUserRole = (selectedData, name, type) => {
        if (type === 'client' && !isNull(selectedData)) {
            setUserRole(selectedData.display)
            setUserRoleid(selectedData.value)

            // Remove this role from additional roles if it's there
            if (additionalRoles) {
                const rolesArray = additionalRoles.split(',').map(id => id.trim());
                if (rolesArray.includes(String(selectedData.value))) {
                    const filteredRoles = rolesArray.filter(roleId => roleId !== String(selectedData.value));
                    setAdditionalRoles(filteredRoles.join(', '));
                    setInitialAdditionalRoles(prev => prev.filter(item => String(item.value) !== String(selectedData.value)));
                }
            }
        } else if (type === 'server' && !isNull(selectedData)) {
        } else {
            setUserRole('')
            setUserRoleid('')
        }
        return selectedData
    }
    //   const [RolesData, setRolesData] = useState([]);

    //     const LoadRolesData = () => {
    //         setIsLoading(true);
    //         ServerRequestProtected(API_URL_General + "/FindByMultipleCriteria", 'post', {
    //           "TableName": enumUtil.enumAPITableName.Roles,
    //         }).then((response) => {
    //           setRolesData(response.Rows)
    //         }).catch((error) => {
    //           setRolesData([])
    //         })
    //       }
    useEffect(() => {
        if (!isNull(userID)) {
            ServerRequestProtected(API_URL + "/FindPracticesByUserID", 'post', {
                "SelectedUserID": userID,
                "TableName": enumUtil.enumAPITableName.User
            }).then((response) => {
                let a = response.filter(item => item.Deleted === false)
                FindByPracrice(response[0].PracticeID);
                setAssignedPractices(response);
                const filteredArrB = practicesDropDown.filter(
                    itemB => {
                        return !response.some(itemA => itemA.PracticeID == itemB.value)
                    })
                ///// Alternate Approach ->>>>
                // let responseIDs = response.map(item => item.PracticeID);
                // let updatedDropdown = practicesDropDown.filter(item => {
                //     return (
                //         !responseIDs.includes(item.value)
                //     )
                // })
                setPracticesDropDown(filteredArrB);
                // setIsLoading(false)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }, [userID])
    const handlePracticeChange = (e) => {
        setIs(false)
        setPracticeName(e.target.value)
    }
    const onRowSelection = (listOfIds) => {
        // console.log("objectCLG", listOfIds)
        if (isAssigned.isLocationAssigned && isAssigned.isProviderAssigned && isAssigned.isSaved) {
            const selectedRowsArray = Array.from(new Set([...listOfIds]));
            const lastitem = selectedRowsArray[selectedRowsArray.length - 1];
            setSelectedRows(new Set([lastitem]));
            FindByPracrice(lastitem)

        }
        else if (!isAssigned.isLocationAssigned && !isAssigned.isProviderAssigned && !isAssigned.isSaved) {
            NotificationHandler("Please Assign Provider and Location", enumUtil.enumtoaster.error);
        }
        else if (!isAssigned.isProviderAssigned) {
            NotificationHandler("Please Assign Provider", enumUtil.enumtoaster.error);
        }
        else if (!isAssigned.isLocationAssigned) {
            NotificationHandler("Please Assign Location", enumUtil.enumtoaster.error);
        }
        else if (!isAssigned.isSaved) {
            NotificationHandler("Please Save Assigned Record", enumUtil.enumtoaster.error);
        }
    }
    const handleSelectPractice = (selectedData, name, type) => {
        if ((!isNull(selectedData))) {
            if (isAssigned.isProviderAssigned && isAssigned.isLocationAssigned && isAssigned.isSaved) {
                console.log("selectedData", selectedData)
                setconfirmPractice(true);
                setPracticeName(selectedData.display);
                setPracticeModal(selectedData);
            }
            else if (!isAssigned.isProviderAssigned && !isAssigned.isLocationAssigned && !isAssigned.isSaved) {
                NotificationHandler("Please Assign Provider and Location", enumUtil.enumtoaster.error);
            }
            else if (!isAssigned.isProviderAssigned) {
                NotificationHandler("Please Assign Provider", enumUtil.enumtoaster.error);
            }
            else if (!isAssigned.isLocationAssigned) {
                NotificationHandler("Please Assign Location", enumUtil.enumtoaster.error);
            }
            else if (!isAssigned.isSaved) {
                NotificationHandler("Please Save Assigned Record", enumUtil.enumtoaster.error);
            }
        } else {
            setPracticeName("");
        }
        // onClosePractice()
    }
    const handleRemovePractice = (id) => {
        let practices = [...assignedPractices]
        practices.map((item) => {
            if (item.PracticeID === id) {
                item.Deleted = true
                let data = { display: item.PracticeName, value: item.PracticeID }
                setPracticesDropDown([...practicesDropDown, data]);
                setIsAssigned(Assigned_Modal);
            }
        })
        let updatedList = practices.filter(item => item.Deleted === false)
        if (id === practiceID) {
            setIsAssigned(Assigned_Modal);
        }
        setAssignedPractices(updatedList);
    }
    const handleChangeunAssignedProvider = (index) => {
        const updatedProviders = [...unAssignedProviders];
        updatedProviders[index].isChecked = !updatedProviders[index].isChecked;
        setunAssignedProviders(updatedProviders);
    };
    const handleSelectAllUnAssignedProviders = (e) => {
        let updatedProviders = [...unAssignedProviders];
        let updatedArray = []
        if (e.target.checked) {
            setIsCheckedAllProviders(true)
            updatedArray = updatedProviders.map(item => ({ ...item, isChecked: true }))
        } else {
            setIsCheckedAllProviders(false)
            updatedArray = updatedProviders.map(item => ({ ...item, isChecked: false }))
        }
        setunAssignedProviders(updatedArray)
    }
    const handleChangeAssignedProviders = (index) => {
        const updatedProviders = [...AssignedProviders];
        updatedProviders[index].isChecked = !updatedProviders[index].isChecked;
        setAssignedProviders(updatedProviders);
    };
    const handleChangeunAssignedLocation = (index) => {
        const updatedLocations = [...unAssignedLocations];
        updatedLocations[index].isChecked = !updatedLocations[index].isChecked;
        setunAssignedLocations(updatedLocations);
    }
    const handleSelectAllUnAssignedLocation = (e) => {
        const updatedLocations = [...unAssignedLocations];
        let updatedArray = [];
        if (e.target.checked) {
            setIsCheckedAllLocations(true);
            updatedArray = updatedLocations.map(item => ({ ...item, isChecked: true }))
        } else {
            setIsCheckedAllLocations(false);
            updatedArray = updatedLocations.map(item => ({ ...item, isChecked: false }))
        }
        setunAssignedLocations(updatedArray)
    }
    const handleChangeAssignedLocation = (index) => {
        const updatedLocations = [...AssignedLocations];
        updatedLocations[index].isChecked = !updatedLocations[index].isChecked;
        setAssignedLocations(updatedLocations);
    }
    const handleSwitchProviders = async () => {
        const selectedProvidersTrue = AssignedProviders.filter((item) => item.isChecked);
        const selectedProvidersFalse = AssignedProviders.filter((item) => item.isChecked === false)
        const selectedunAssignedProvidersTrue = unAssignedProviders.filter((item) => item.isChecked);
        const selectedunAssignedProvidersFalse = unAssignedProviders.filter((item) => item.isChecked === false);
        setAssignedProviders([...selectedProvidersFalse, ...selectedunAssignedProvidersTrue])
        setunAssignedProviders([...selectedunAssignedProvidersFalse, ...selectedProvidersTrue])
        await setIsChecktoFalseProvider()
        if ([...selectedProvidersFalse, ...selectedunAssignedProvidersTrue].length !== 0) {
            setIsAssigned({ ...isAssigned, isProviderAssigned: true });
        } else if ([...selectedProvidersFalse, ...selectedunAssignedProvidersTrue].length === 0 && !isAssigned.isSaved) {
            setIsAssigned({ ...isAssigned, isProviderAssigned: false });
        }
        setIsCheckedAllProviders(false);
    }
    const setIsChecktoFalseProvider = async () => {
        AssignedProviders.map((item) => {
            item.isChecked = false
        })
        unAssignedProviders.map((item) => {
            item.isChecked = false
        })
    }
    const handleSwitchLocation = async () => {
        const selectedLocationTrue = AssignedLocations.filter((item) => item.isChecked);
        const selectedLocationFalse = AssignedLocations.filter((item) => item.isChecked === false);
        const selectedunAssignedLocationTrue = unAssignedLocations.filter((item) => item.isChecked);
        const selectedunAssignedLocationFalse = unAssignedLocations.filter((item) => item.isChecked === false);
        setAssignedLocations([...selectedLocationFalse, ...selectedunAssignedLocationTrue])
        setunAssignedLocations([...selectedunAssignedLocationFalse, ...selectedLocationTrue])
        await setIsChecktoFalseLocation();
        if ([...selectedLocationFalse, ...selectedunAssignedLocationTrue].length !== 0) {
            setIsAssigned({ ...isAssigned, isLocationAssigned: true });
        } else if ([...selectedLocationFalse, ...selectedunAssignedLocationTrue].length === 0 && !isAssigned.isSaved) {
            setIsAssigned({ ...isAssigned, isLocationAssigned: false });
        }
        setIsCheckedAllLocations(false);
    }
    const setIsChecktoFalseLocation = async () => {
        AssignedLocations.map((item) => {
            item.isChecked = false
        })
        unAssignedLocations.map((item) => {
            item.isChecked = false
        })
    }
    const onCancelPractice = () => {
        setIs(true)
        setPracticeName('')
        setconfirmPractice(false)

    }
    const onClosePractice = () => {
        setconfirmPractice(false)
        setIs(true)

    }
    const onSelectPractice = () => {
        if (isAssigned.isProviderAssigned && isAssigned.isLocationAssigned && isAssigned.isSaved) {

            let data = { id: practiceModal.value + "", PracticeName: practiceModal.display, PracticeID: practiceModal.value + "", Deleted: false, AssignedDate: '' }
            setAssignedPractices([...assignedPractices, data])
            setIsAssigned({ ...isAssigned, isPracticeAssigned: true, isLocationAssigned: false, isProviderAssigned: false, isSaved: false });
            let filteredPractices = practicesDropDown.filter(item => item.value !== practiceModal.value);
            setPracticesDropDown(filteredPractices);
            FindByPracrice(practiceModal.value);
            const idSet = new Set([practiceModal.value + ""])
            onRowSelection(idSet);
            setPracticeID(practiceModal.value);
            setSelectedPracticeID(practiceModal.value);
            // setPracticeName(practiceModal.display)
            // onCancelPractice()
            onClosePractice()
        }
    }

    // Reset Password
    let Password_Modal = {
        Password: '',
        NewPassword: '',
        ConfirmPassword: '',
    }
    let PassVal_Modal = {
        Password: '',
        NewPassword: '',
        ConfirmPassword: '',
        PasswordMatch: '',
    }
    let PassValModal = {}
    let ShowPass_Modal = {
        ShowOldPassword: false,
        ShowNewPassword: false,
        ShowConfirmPasswrod: false,
    }
    const [mainPasswordModal, setMainPasswordModal] = useState(Password_Modal);
    const [savePasswordModal, setSavePasswordModal] = useState({});
    const [passwordValidation, setPasswordValidation] = useState(PassVal_Modal);
    const [showPasswordModal, setShowPasswordModal] = useState(ShowPass_Modal)
    const ComparePassword = (newPassword, confirmPassword) => {
        if (!isNull(newPassword) && !isNull(confirmPassword)) {
            if (newPassword !== confirmPassword) {
                return (
                    <div className="invalid-feedback" style={{ display: "block" }}>
                        Confirm and New passwords are not equal.
                    </div>
                )
            } else {
                return ''
            }
        }
    }
    const validatePasswordStrength = (password) => {
        if (!password) return 'Password is required';

        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumber = /[0-9]/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        const isLongEnough = password.length >= 8;

        if (!isLongEnough || !hasUpperCase || !hasLowerCase || !hasNumber || !hasSpecialChar) {
            return 'Your password must be at least 8 characters long and include a number, lowercase, uppercase letters, and a special character.';
        }

        return '';
    };

    const PasswordValidation = async () => {
        let validation = {
            Password: FormValidator(mainPasswordModal.Password, enumUtil.enumValidationType.Required, 'Old Password'),
            NewPassword: FormValidator(mainPasswordModal.NewPassword, enumUtil.enumValidationType.Required, 'New Password'),
            ConfirmPassword: FormValidator(mainPasswordModal.ConfirmPassword, enumUtil.enumValidationType.Required, 'Confirm Password'),
            PasswordMatch: ComparePassword(mainPasswordModal.NewPassword, mainPasswordModal.ConfirmPassword),
            PasswordStrength: validatePasswordStrength(mainPasswordModal.NewPassword)
        };
        setPasswordValidation(validation);
        PassValModal = validation;

        return validation;
    };

    const handlePasswordSave = async () => {
        const validationResults = await PasswordValidation();

        const isAnyValidationFailed = Object.values(validationResults).some(val => val !== '');

        if (isAnyValidationFailed) {

            return;
        }
        let saveModal = {
            TableName: enumUtil.enumAPITableName.User,
            ID: userID,
            data: {
                ...savePasswordModal
            }
        };

        setIsLoading(true);

        ServerRequestProtected(API_URL + '/ChangeUserPassword', 'post', saveModal)
            .then((response) => {
                NotificationHandler('Password Reset Successfully', enumUtil.enumtoaster.success);
                setIsLoading(false);
            })
            .catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                setIsLoading(false);
            });
    };

    const handleOnClosePassword = () => {
        setMainPasswordModal(Password_Modal);
        setSavePasswordModal({});
        setPasswordValidation(PassVal_Modal);
    }
    const handlePasswordOnChange = (e) => {
        const { name, value } = e.target;
        const modal = { ...mainPasswordModal };
        const saveModal = { ...savePasswordModal };
        modal[name] = value;
        setMainPasswordModal(modal);
        for (let property in modal) {
            if (property === name) {
                saveModal[name] = value;
            }
        }
        setSavePasswordModal(saveModal);
    }

    // Billing Rights
    const [UserRights, setUserRights] = useState([])
    const handleSaveUserRoles = (data) => {
        setUserRights(data)
    }
    const [activeTab, setActiveTab] = useState(1)


    const RemovePicture = () => {
        setmainUserModal({ ...mainUserModal, Picture: "" })
        setUserSaveUpdateModal({ ...UserSaveUpdateModal, Picture: "" })
    }

    // others
    const handleSaveUser = async () => {
        await UserValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        console.log(validation, 'validation');
        // if (validation) {
        //     NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
        //     return
        // }
        if (validation) {
            const isRoleMissing = !!valModal?.UserRoleVal;
            const otherFieldsMissing = Object.keys(valModal).some(
                key => key !== "UserRoleVal" && !!valModal[key]
            );
            if (isRoleMissing && !otherFieldsMissing) {
                NotificationHandler("please assign profile", enumUtil.enumtoaster.error);
            } else {
                NotificationHandler("Fill Required Fields", enumUtil.enumtoaster.error);
            }
            return;
        }
        else {
            // if (assignedPractices?.length > 0) {
            //     console.log("isAssigned",isAssigned)
            //     setIsAssigned({ ...isAssigned, isPracticeAssigned: true })
            // }
            if (isAssigned.isPracticeAssigned && isAssigned.isRoleAssigned && isAssigned.isLocationAssigned && isAssigned.isProviderAssigned) {
                let User = {
                    TableName: enumUtil.enumAPITableName.User,
                    ID: userID,
                    data: { ...UserSaveUpdateModal },
                }
                assignedPractices.map((item) => {
                    item.PracticeID = item.PracticeID + ""
                    item.Deleted = item.Deleted + ""
                })
                let UserPractices = [...assignedPractices]
                AssignedLocations.map((item) => {
                    item.LocationID = item.LocationID + ""
                    item.isChecked = item.isChecked + ""
                    item.practiceID = selectedPracticeID + ""
                })
                let UserLocation = [...AssignedLocations]
                AssignedProviders.map((item) => {
                    item.ProviderID = item.ProviderID + ""
                    item.isChecked = item.isChecked + ""
                    item.practiceID = selectedPracticeID + ""
                })
                let UserProvider = [...AssignedProviders]
                let UserRight = UserRights

                let additionalRolesArray = [];

                if (additionalRoles) {
                    const roleIds = additionalRoles.split(',').map(id => id.trim());
                    roleIds.forEach(roleId => {
                        if (String(roleId) !== String(UserRoleid)) {
                            additionalRolesArray.push({
                                PracticeID: parseInt(selectedPracticeID),
                                RoleID: parseInt(roleId)
                            });
                        }
                    });
                }

                let UserRoles = {
                    PracticeRoleID: UserRoleid + "",
                    UserPracticeID: selectedPracticeID ? selectedPracticeID + '' : ''
                }

                let saveModal = {
                    User,
                    UserPractices,
                    UserLocation,
                    UserProvider,
                    UserRight,
                    UserRoles,
                    additionalRoles: additionalRolesArray
                }
                setIsLoading(true)
                ServerRequestProtected(API_URL + "/AssignPractices", 'post', saveModal)
                    .then((response) => {
                        if (!isNull(response.id)) {
                            UpdateReduxDropDowns(userID, DropDowns.User, response.id, mainUserModal.FirstName + "-" + mainUserModal.LastName)
                            setIsLoading(false)
                            NotificationHandler('User Created Successfully', enumUtil.enumtoaster.success)
                            setUserID(response.id)
                            setonUserSaved(true);
                            setisUserSaved(Math.random())
                            setIsAssigned({ ...isAssigned, isSaved: true, })
                            onDeleteUser()
                        }
                    }).catch((error) => {
                        setIsLoading(false)
                        console.log("ERROR", error);
                        NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                    })
            } else if (!isAssigned.isLocationAssigned && !isAssigned.isProviderAssigned) {
                NotificationHandler("Please Assign Provider and Location", enumUtil.enumtoaster.error);
            }
            else if (!isAssigned.isProviderAssigned) {
                NotificationHandler("Please Assign Provider", enumUtil.enumtoaster.error);
            }
            else if (!isAssigned.isLocationAssigned) {
                NotificationHandler("Please Assign Location", enumUtil.enumtoaster.error);
            }
            else if (!isAssigned.isRoleAssigned && !isAssigned.isPracticeAssigned) {
                setActiveTab(2)
                NotificationHandler("Please Assign Role and Practice", enumUtil.enumtoaster.error);
            }
            // else if (!isAssigned.isRoleAssigned) {
            //     NotificationHandler("Please Assign Role", enumUtil.enumtoaster.error);
            // }
            else if (!isAssigned.isPracticeAssigned) {
                NotificationHandler("Please Assign Practice", enumUtil.enumtoaster.error);
            }
            else if (!isAssigned.isSaved) {
                NotificationHandler("Please Save Assigned Record", enumUtil.enumtoaster.error);
            }


        }
    }
    const TabsMenu = [
        {
            name: 'Basic Information',
            key: 1,
            icon: "",
            right: true,
        },
        {
            name: 'Assigned Profiles',
            key: 2,
            icon: "",
            right: true,
        },

        {
            name: 'Reset Password',
            key: 4,
            icon: "",
            right: isNull(userID) ? false : true,
        },

        ...(IsDeleteAllowed
            ?
            [{
                name: 'Deactivate User',
                key: 3,
                icon: "",
                right: isNull(userID) ? false : true,
            }]

            : [])
    ]
    const handleActiveTab = (item) => {
        if (!item?.right) {
            return; // If the tab is disabled, do nothing
        } else {
            setActiveTab(item.key)
        }
    }
    useEffect(() => {
        setIsAssigned((prev) => {
            let newState = { ...prev }
            if (!isNull(UserRole) && !prev.isRoleAssigned) {
                newState.isRoleAssigned = true
            }
            if (assignedPractices?.length > 0 && !prev.isPracticeAssigned) {
                newState.isPracticeAssigned = true
            }

            return newState
        })
    }, [UserRole, assignedPractices])


    return (
        <React.Fragment>
            {DeleteConfirmation}
            <Modal show={isOpenUser} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 modal-xxl add_user">
                {AuditPopup}
                <Modal.Body>
                    <ModalHeader HeaderName={SetUserName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onClose} key={612} Name={'Location'} />
                    {isLoading ? <Loader /> : null}
                    <div className="inside_body">
                        <div className="d-flex h-100 hk-flex">
                            <div className="tab-menu-sidebar">
                                <div className="menu-box">
                                    <Nav className="rb-tabs hk-tabs-col nav-tabs">
                                        {TabsMenu && TabsMenu.map((item) => {
                                            return (
                                                <React.Fragment key={item.key}>
                                                    <NavItem onClick={() => handleActiveTab(item)}>
                                                        <NavLink href="#" className={activeTab === item.key ? "active" : ""} disabled={item.right}>
                                                            {item.name}
                                                            {activeTab === item.key && <i className="icon-Icon-awesome-check-circle"></i>}
                                                        </NavLink>
                                                    </NavItem>
                                                </React.Fragment>
                                            )
                                        })}
                                    </Nav>
                                </div>
                            </div>
                            <div className="tab-content-col right_info_panel">
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId={1}>
                                        <BasicInformation
                                            mainUserModal={mainUserModal}
                                            UserValidationModal={UserValidationModal}
                                            handleUserChange={handleUserChange}
                                            handleSelectedData={handleSelectedData}
                                            handleImageChange={handleImageChange}
                                            RemovePicture={RemovePicture}
                                            is={is}
                                            RolesDD={RolesDD}
                                        />
                                    </TabPane>
                                    <TabPane tabId={2}>
                                        <AssignedProfile
                                            practiceName={practiceName}
                                            handlePracticeChange={handlePracticeChange}
                                            handleSelectPractice={handleSelectPractice}
                                            is={is}
                                            assignedPractices={assignedPractices}
                                            columns={columns}
                                            handleChangeAssignedProviders={handleChangeAssignedProviders}
                                            AssignedProviders={AssignedProviders}
                                            handleChangeunAssignedProvider={handleChangeunAssignedProvider}
                                            unAssignedProviders={unAssignedProviders}
                                            handleChangeAssignedLocation={handleChangeAssignedLocation}
                                            AssignedLocations={AssignedLocations}
                                            handleChangeunAssignedLocation={handleChangeunAssignedLocation}
                                            unAssignedLocations={unAssignedLocations}
                                            handleSwitchProviders={handleSwitchProviders}
                                            handleSwitchLocation={handleSwitchLocation}
                                            FindByPracrice={FindByPracrice}
                                            isCheckedAllProviders={isCheckedAllProviders}
                                            isCheckedAllLocations={isCheckedAllLocations}
                                            PracicesDropDown={practicesDropDown}
                                            handleSelectAllUnAssignedProviders={handleSelectAllUnAssignedProviders}
                                            handleSelectAllUnAssignedLocation={handleSelectAllUnAssignedLocation}
                                            onRowSelection={onRowSelection}
                                            selectedRows={selectedRows}
                                            RolesData={UserRolesDD}
                                            UserRole={UserRole}
                                            UserRoleid={UserRoleid}  // ADD THIS LINE
                                            handleChangeUserRole={handleChangeUserRole}
                                            handleSelectUserRole={handleSelectUserRole}
                                            UserValidationModal={UserValidationModal}
                                            additionalRoles={additionalRoles}
                                            setAdditionalRoles={setAdditionalRoles}
                                            initialAdditionalRoles={initialAdditionalRoles}
                                            setInitialAdditionalRoles={setInitialAdditionalRoles}
                                            selectedPracticeID={selectedPracticeID}
                                            activeTab={activeTab}
                                            additionalRolesKey={additionalRolesKey}
                                        />
                                    </TabPane>
                                    {IsDeleteAllowed ?
                                        <TabPane tabId={3}>
                                            <DeactiveUser
                                                userID={userID}
                                                // handleSaveUserRoles={handleSaveUserRoles}
                                                isUserSaved={isUserSaved}
                                                DeActiveData={deActive}
                                                FindByID={FindByPracrice}
                                                GridApi={Refreash}


                                            />
                                        </TabPane>
                                        :
                                        null
                                    }

                                    <TabPane tabId={4}>
                                        <ResetUserPassword
                                            mainPasswordModal={mainPasswordModal}
                                            handlePasswordOnChange={handlePasswordOnChange}
                                            passwordValidation={passwordValidation}
                                            showPasswordModal={showPasswordModal}
                                            handleOnClosePassword={handleOnClosePassword}
                                            handlePasswordSave={handlePasswordSave}
                                            setShowPasswordModal={setShowPasswordModal}
                                        />
                                    </TabPane>
                                </TabContent>
                            </div>
                        </div>
                    </div>
                    {/* <div className='tab-action-bottom'>

                        <div className='btns-group text-end pt-2 br-top-1 br-clr d-flex align-items-center justify-content-between h-100'>

                            <div className='ms-3'>
                                {!isNull(mainUserModal.CreatedBy) ?
                                    <p className='heading heading_ext'>Created By/Date: <span className='text text_color'>{mainUserModal.CreatedBy}, {mainUserModal.CreatedDate}</span></p>
                                    : null}
                            </div>

                            <div>
                                <button class="btn btn-gray me-2" onClick={onClose}>Cancel</button>
                                <button className={IsEditAllowed ? 'btn btn-orange' : 'btn btn-orange disabled'} onClick={handleSaveUser}> Save</button>
                            </div>

                        </div>
                    </div> */}
                </Modal.Body>
                <ModalFooter isSaved={onClose} handleSave={handleSaveUser} key={641} Name={'Addnewuser'} UpdatedDate={mainUserModal.UpdatedDate} UpdatedBy={mainUserModal.UpdatedBy} ID={userID} IsEditAllowed={IsEditAllowed} />

                {/* <div class="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between">
                    <div class="update-info">
                        <p class="ms-1">Recent Updated By: <span class="position-relative">SHEHRYAR</span></p>
                        <p class="ms-1">Date:&nbsp;&nbsp;<span title="12/20/2024 12:35PM">12/20/2024 12:35PM</span>&nbsp;&nbsp;&nbsp;&nbsp;<span></span></p>
                    </div>
                    <div class="btns-group d-flex justify-content-center align-items-center gap-2">
                        <button class="btn btn-outline  px-10 h-100 dark-clr" onClick={onClose}>Cancel</button>
                        <button className={IsEditAllowed ? 'btn  btn-validate px-10 h-100' : 'btn btn-validate px-10 h-100 disabled'} onClick={handleSaveUser}>Save</button>
                    </div>
                </div> */}
            </Modal>
            {/* <Modal show={confirmPractice} onHide={onClosePractice} backdrop="static" keyboard={false} centered dialogClassName="ar_user-delete-modal hk-modal-v1">
                <Modal.Body>
                    <div className="select-practice d-flex justify-content-between">
                        <p className="text text-start fs-14">.</p>
                        <i className="bi bi-x" onClick={() => onClosePractice()}></i>
                    </div>
                </Modal.Body>
                <div className='btns-group modal_footer modal-footer br-clr pb-2'>
                    <button className='btn btn-gray '></button>
                    <button className='btn btn-orange ' ></button>
                </div>

            </Modal> */}

            <Modal show={confirmPractice} onHide={onClosePractice} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 za-update-subscriber-id za-discard-changes za-exit-group ">
                <Modal.Body>
                    <div className="d-flex justify-content-between align-items-center">
                        <p className="heading fs-14 dark-clr">Confirm Selection</p>
                        <i className="icon-x-cros fs-20 fs-20 dark-clr" onClick={() => onCancelPractice()}></i>
                    </div>
                    <div className='ar-alert d-flex align-items-center gap-2 w-100 mb-0 mt-12'>
                        <i className='icon-alert fs-16'></i>
                        <div>
                            <p className='text'>Are u sure you want to select <span className="font-m">{practiceName}</span></p>
                        </div>
                    </div>
                </Modal.Body>

                <div className="modal_footer za_br_light br-top-1 pt-2 ">
                    <div className='za-button text-end d-flex justify-content-end gap-2'>
                        <button className='btn btn-outline fs-12 px-10 rounded drk_clr' onClick={() => onCancelPractice()}>Cancel</button>
                        <button className='btn btn-danger fs-12 px-10 rounded' onClick={() => onSelectPractice()}>Select</button>
                    </div>
                </div>
            </Modal>

        </React.Fragment>
    )
}

export default AddNewUser